import beneficiaries from 'Beneficiaries/ducks/beneficiaries';
import beneficiaryDetail from 'Beneficiaries/ducks/beneficiaryDetail';
import beneficiaryForm from 'Beneficiaries/ducks/beneficiaryForm';

export default {
  beneficiaries,
  beneficiaryDetail,
  beneficiaryForm,
};
